export const IPAD_WIDTH = 768;
export const DURATION29 = 29 * 24 * 60 * 60 * 1000;
export const DURATION30 = 30 * 24 * 60 * 60 * 1000;
export const WAREHOUSE_LUOGU = '3';
export const WAREHOUSE_BECODER = '100';
export const WAREHOUSE_CRM = '110';
export const WAREHOUSE_THIRD_PARTY = [WAREHOUSE_LUOGU, WAREHOUSE_BECODER];
export const WAREHOUSE_THIRD_PARTY_PLATFORM = {
  [WAREHOUSE_LUOGU]: 1,
  [WAREHOUSE_BECODER]: 2,
};
export const QUERY_KEY_FOR_MODEL = 'q';
export const HT_PLATFORM = 'htojWeb';
export const HT_BCXAS = 'htbcxas';
export const HT_APP_ID = 'com.hetao101.oj';
export const TENCENT_TCAPTCHA_APP_ID = '190559420';
export const TENCENT_TCAPTCHA_URL =
  'https://turing.captcha.qcloud.com/TCaptcha.js';
export const WX_SDK_URL =
  'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
// 用户协议 《平台服务协议》
export const PROTOCOL1 = 'https://ug.hetao101.com/KAtOzrHe';
// 隐私政策 《平台隐私政策》
export const PROTOCOL2 = 'https://ug.hetao101.com/5uOc8yRt';
// 儿童隐私政策 《儿童隐私保护声明》
export const PROTOCOL3 = 'https://ug.hetao101.com/NrOd9xmN';
export const VALID_HOST = [
  'hetao101.com',
  'pipacoding.com',
  'hetaoedu.com',
  'htoj.com.cn',
];

// 特殊页面禁止轮训消息接口
// 特殊页面禁止弹窗收集信息
export const EXCLUDE_PAGES = ['oj_entrance_exam'];

// 8-18位，至少包含数字和字母
export const PASSWORD_PATTERN = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,18}$/;
export const URL_PATTERN = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+\.?)(\/[^\s]*)?$/;
export const URL_PATTERN_STRICT =
  /^https?:\/\/([\w-]+(\.[\w-]+)+\.?)(\/[^\s]*)?$/;
export const CODE_INFO_PATTERN = /^[a-z0-9+-]{0,20}$/;
export const SPLIT_PATTERN = /[,，\s]+/;

export const SEX_OPTIONS = [
  { label: '保密', value: 'secrecy' },
  { label: '男生', value: 'boy' },
  { label: '女生', value: 'girl' },
];

export const ACCUSE_STATUS_OPTIONS = [
  { label: '存在待处理举报', value: true },
  { label: '没有待处理举报', value: false },
];
export const PROBLEM_AUTH_OPTIONS = [
  { label: '公开题目', value: 1 },
  { label: '私密题目', value: 2 },
];
export const WAREHOUSE_AUTH_OPTIONS = [
  { label: '公开题库', value: 1 },
  { label: '私密题库', value: 2 },
];
export const TRAINING_AUTH_OPTIONS = [
  { label: '公开题单', value: 1 },
  { label: '私密题单', value: 2 },
];
export const CONTEST_AUTH_OPTIONS = [
  { label: '公开比赛', value: 1 },
  { label: '私密比赛', value: 2 },
];
export const GROUP_AUTH_OPTIONS = [
  { label: '仅通过管理员添加', value: 1 },
  { label: '可直接通过链接加入', value: 2 },
  { label: '需管理员审核加入', value: 3 },
];
export const GROUP_TYPE_OPTIONS = [
  { label: '内部小组', value: 0 },
  { label: 'to B/to G小组', value: 1 },
  { label: '外部小组', value: 2 },
];
export const GROUP_VERIFICATION_OPTIONS = [
  { label: '验题小组', value: 1 },
  { label: '非验题小组', value: 0 },
];
export const GROUP_TYPE = {
  INNER: 0, // 内部小组
  TO_B_TO_G: 1, // to B/to G小组
  OUTER: 2, // 外部小组
};
export const CONTEST_SEAL_RANK_OPTIONS = [
  { label: '比赛结束前半小时', value: 30 },
  { label: '比赛结束前一小时', value: 60 },
  { label: '比赛全程', value: 0 },
];
export const CONTEST_AUTO_REAL_RANK_OPTIONS = [
  { label: '比赛完取消封榜', value: 1 },
  { label: '比赛完继续封榜', value: 0 },
];
export const CALCULATE_TYPE_OPTIONS = [
  { label: 'SUM', value: 1 },
  { label: 'MAX', value: 2 },
  { label: 'MIN', value: 3 },
];

export const IO_MODES = [
  {
    label: '标准IO',
    value: 1,
    id: 'STANDARD',
  },
  {
    label: '文件IO',
    value: 2,
    id: 'FILE',
  },
];

export const JUDGE_MODE_VALUES = {
  DEFAULT: 'default',
  SPJ: 'spj',
  SUBMIT_ANSWER: 'submitAnswer',
  INTERACTIVE: 'interactive',
} as const;

export const JUDGE_MODES = [
  { label: '普通判题', value: JUDGE_MODE_VALUES.DEFAULT },
  { label: '特殊判题', value: JUDGE_MODE_VALUES.SPJ },
  { label: '提交答案判题', value: JUDGE_MODE_VALUES.SUBMIT_ANSWER },
  { label: '交互判题', value: JUDGE_MODE_VALUES.INTERACTIVE },
];
export const ANSWER_AUTHS = [
  {
    label: '所有人可查看',
    value: 1,
  },
  {
    label: '提交用户可查看',
    value: 2,
  },
  {
    label: '有测试点通过用户可查看',
    value: 5,
  },
  {
    label: '通过用户可查看',
    value: 3,
  },
  {
    label: '管理员可查看',
    value: 4,
  },
];

export const SPJ_LANGUAGES = [
  // {
  //   label: 'Python3',
  //   value: 10,
  // },
  {
    label: 'C++14 With O2',
    value: 6,
  },
  {
    label: 'C++17 With O2',
    value: 7,
  },
];

export const LANGUAGE_CODE_CPP14 = 6;
export const LANGUAGE_CODE_CPP17 = 7;
export const LANGUAGE_CODE_PYTHON = 10;

export const AC_STATUS = {
  CORRECT: 4,
  ERROR: 3,
  CODE: 2,
  UNLOGIN: 1,
};

/** 题目列表页 - 答题状态筛选 */
export const ANSWER_STATUS = {
  CORRECT: 1,
  ERROR: 2,
  UNSUBMITTED: 3,
};

export const TRAINING_STATUS = {
  CORRECT: 4,
  PAUSE: 3,
  CODE: 2,
};

export const SUBMISSION_STATUSES = {
  CompileError: 7,
  PresentationError: 1,
  WrongAnswer: 4,
  Accepted: 0,
  TimeLimitExceeded: 2,
  MemoryLimitExceeded: 3,
  RuntimeError: 5,
  SystemError: 8,
  OutputLimitExceeded: 6,
  Judging: -10,
  Submitted: 99,
};

export const SUBMISSION_RESULT_CODES = {
  PENDDING: 0,
  SUCCESS: 1,
  FAILURE: 2,
  NOT_SHOW_RESULT: 3,
  PURE_CODE: 4,
};

export const OPTION_ALL_ID = -9999;
export const OPTION_ALL_NAME = '全部';

export const CONTEST_STATUSES = {
  UNSTART: -1,
  IN_PROGRESS: 0,
  END: 1,
};
export const CONTEST_STATUS_OPTIONS = [
  { label: '未开始', value: -1 },
  { label: '进行中', value: 0 },
  { label: '已结束', value: 1 },
];

export const PROBLEM_TYPES = {
  OJ: 1,
  CHOICE: 2,
  OBJECT: 5,
};

export const CHOICE_TYPES = {
  SINGLE: 2, // 单选
  MUTIL: 4, // 多选
};
export const CONTEST_TYPES = {
  OI: 1,
  ACM: 2,
  LEETCODE: 3, //乐多
  IOI: 4,
  'IOI(OFS)': 5,
  STRICT_IOI: 6, //自创的严格IOI
};
export const SHARE_CODE = {
  DISABLED: 0,
  OPTIONAL: 1,
  FORCED: 2,
} as const;
export const CONTEST_PROBLEM_STATUSES = {
  NOT_PARTICIPATE: -1,
  NOT_PASSED: 0,
  PASSED: 1,
  NOT_SUBMITTED: 2,
  SUBMITTED: 3,
  JUDGING: 4,
};

export const PROBLEM_TABS = {
  DESC: '1',
  SOLUTION: '2',
  SUBMIT_LIST: '3',
};

export const ZONE_OPTIONS = [
  { label: 'C++', value: 'cpp' },
  { label: 'Python', value: 'python' },
];

export const ZONE_KEY_MAP = {
  DIFFICULTY: 'difficulty',
  CONTEST_TYPE: 'contestType',
  SELECTION_TYPE: 'selectionType',
};

export const OPTIONS_KEY_MAP = {
  EVENT: 'event', // 任务达成条件事件类型
  REPETITIVE: 'repetitive', // 任务周期类型
};

export const PROBLEM_ANSWER_STATUS = {
  UNANSWERED: -1,
  SUCCESS: 1,
  FAILURE: 2,
  ANSWERED: 3,
};

export const CROSS_ZONE_WHITELIST = [
  'discuss/post/create',
  'discuss/category/academic',
  'discuss/category/general',
  'oj/profile',
  'oj/home/problem',
  'oj/home/training',
  'oj/home/contest',
  'oj/home/group',
  'oj/home/post',
  'oj/home/post/reply',
  'oj/problem',
  'oj/training',
  'oj/contest',
  'oj/group',
  'admin',
  'admin/problem/list',
  'admin/warehouse/list',
  'admin/training/list',
  'admin/contest/list',
  'admin/group/list',
  'admin/user',
  'admin/tag/list',
  'admin/tag/category',
  'admin/indexconfig/article',
  'admin/indexconfig/banner',
];
export const FONT_SIZE_LIST = [12, 14, 16, 18, 20, 24, 32].map((item) => ({
  label: item + 'px',
  value: item + 'px',
}));

export const EDITOR_THEME_CACHE_KEY = 'monaco_editor_theme';
export const EDITOR_FONT_SIZE_CACHE_KEY = 'editor_font_size';

// 小组权限 1为仅通过管理员，2直接通过链接，3需要管理员审核
export const GROUP_JOIN_OPTIONS = { MANUAL: 1, AUTO: 2, AUDIT: 3 };

// 成员状态 0 不是成员 1已经申请了 2被拒绝 3已经是成员了
export const MEMBER_STATUS_OPTIONS = {
  NOT_MEMBER: 0,
  APPLIED: 1,
  REJECTED: 2,
  MEMBER: 3,
};

export const MEMBER_ROLES = {
  NORMAL_MEMBER: 3,
  TEAM_ADMIN: 4,
  TEAM_OWNER: 5,
};

export const GROUP_APPLY_STATUSES = {
  NO_REVIEW: 0, // 无需审核
  SUBMITTED: 1, // 提交审核
  APPROVED: 2, // 通过
  REJECTED: 3, // 拒绝
};

export const CONTEST_REMARKS = {
  IN_CONTEST: 1,
  AFTER_CONTEST: 2,
};

export const CONTEST_REMARK_OPTIONS = [
  { label: '赛中提交', value: CONTEST_REMARKS.IN_CONTEST },
  { label: '赛后补题', value: CONTEST_REMARKS.AFTER_CONTEST },
];

export const CONTEST_REGISTER_STATE = {
  NOT_VERIFIED: 0, // 校验未通过
  VERIFIED_NEED_INFO: 1, // 待收集信息
  VERIFIED_NO_NEED_REGISTRATION: 2, // 校验通过无需报名也无需填信息
  REGISTERED: 3, // 已报名
};

export const LANTERN_TEAM_ICE = '冰冰蛇';
export const LANTERN_TEAM_FIRE = '火火蛇';

export const POSTER_TYPE = {
  DISCUSS: 1,
  POST: 1, // 讨论
  SOLUTION: 2, // 题解
  PROBLEM: 3,
  USER_AWARD_APPLY: 4, // 奖项
  LIKE: 5, // 点赞
  AI_SOLUTION_VERSION: 6, // AI题解改进版本
  SOLUTION_INLINE_COMMENT: 7, // AI题解划线评论
};

export const AUDIT_STATE = {
  REVIEWING: 0, // 审核中
  REJECTED: -1, // 审核不通过
  APPROVED: 1, // 审核通过
  APPROVED_AND_ESSENTIAL: 3, //通过并加精
};

// 申诉审核动作（题解走 problemSolution/appealAudit，AI 改进版本合并到 aiSolutionVersion/audit，
// 均为 1=通过 -1=不通过，后端按当前状态分派申诉/首审并发送对应站内信）
export const APPEAL_AUDIT_STATE = {
  PASS: 1, // 申诉通过
  REJECT: -1, // 申诉不通过
};

export const POST_STATUS = {
  ALL: 0, // 全部
  ONE: 1, // 待审核
  TWO: 2, // 机审不通过
  THREE: 3, // 人审不通过
  FOUR: 4, // 用户主动删除
  FIVE: 5, // 管理删除
  SIX: 6, // 公开
  SEVEN: 7, // 上级内容已删除
  EIGHT: 8, // 质检不通过
  NINE: 9, // 通过仅自己可见
};

export const USER_AWARD_REVIEW_STATUS = [
  { label: '待人工审核', value: 1 },
  { label: '通过未领取', value: 2 },
  // { label: '通过已领取', value: 3 },
  { label: '驳回', value: 4 },
];

export const PIN_STATUS = {
  DEFAULT: 0, // 默认状态，未置顶
  PINNED: 1, // 已置顶
};

export const PIN_OPTIONS = [
  { label: '置顶评论', value: 1 },
  { label: '未置顶评论', value: 0 },
];

export const COMPLETION_MODE_OPTIONS = [
  { label: '连续阶梯', value: 1 },
  { label: '累计阶梯', value: 2 },
];

export const GOODS_MISSION_TYPE_OPTIONS = [
  { label: '谷子', value: 1 },
  { label: '粽子', value: 2 },
];

export const REPETITIVE_UNIT_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
];

export const USER_LEVEL_COLORS = [
  '#AFB6D3',
  '#AFB6D3',
  '#AFB6D3',
  '#4BB5EF',
  '#4BB5EF',
  '#4BB5EF',
  '#00B400',
  '#00B400',
  '#00B400',
  '#FF8C00',
  '#FF8C00',
  '#FF8C00',
  '#FF0000',
  '#FF0000',
  '#FF0000',
];

export const MISSION_TASK_TYPES = {
  NORMAL: 1,
  RANDOM: 2,
};

export const MISSION_TASK_STATUS = {
  LOTTERY: 0,
  UNFINISHED: 1,
  FINISHED: 2,
  RECEIVED: 3,
};

export const EQUIP_TYPES = {
  CURSOR_TRAILS: 1,
  AVATAR_FRAME: 2,
  GRADE_DECORATION: 3,
  HOME_BACKGROUND: 4,
};

export const BADGE_CATEGORY = {
  GOODS: 1,
  CHALLENGE: 2,
  ACTIVITY: 3,
  GALAXY: 4,
};

/** 谷子最多可佩戴数量（后端同步限制） */
export const MAX_EQUIP_BADGE_COUNT = 6;

/** 银河争霸赛默认头像（核桃OJ官方形象） */
export const GALAXY_DEFAULT_AVATAR =
  'https://public.hetaoimg.com/code-community/markdownImg/prod/2c3fd7b1e84c470cb2c04b23b2c660f0.png';

export const EXAM_TYPE = {
  OJ: 1,
  OBJECTIVE: 5,
};

export const CPP_PROGRAM_LEVEL_OPTIONS = [
  { label: '基础语法入门', value: 1 },
  { label: '在学CSP-J', value: 2 },
  { label: '在学CSP-S', value: 3 },
  { label: 'CSP-S以上', value: 4 },
];

export const PYTHON_PROGRAM_LEVEL_OPTIONS = [
  { label: '初学者', value: 1 },
  { label: '基础语法熟练', value: 2 },
  { label: '算法入门', value: 3 },
  { label: '算法熟练', value: 4 },
];

export const MISSION_TASK_EVENT = {
  VISIT_OJ: 1, // 访问OJ平台
  SUBMIT_PROBLEM: 2, // 提交题目
  FIRST_AC: 3, // AC题目（首次）
  AC: 4, // AC题目（非首次）
  REGISTER_CONTEST: 5, // 报名比赛
  CONTEST_SUBMISSION: 6, // 比赛中有提交行为
  REGISTER_TRAINING: 7, // 参与题单（加入）
  TRAINING_SUBMISSION: 8, // 提交题单（有提交行为)
  TRAINING_COMPLETION: 9, // 公域题单完成事件
  NOVICE_TASK: 10, // 新手任务
  FILL_IN_INFORMATION: 11, // 完善个人信息
};
export const FRESH_TASK_STATUS = {
  UNOWNED: 0,
  UNFINISHED: 1,
  FINISHED: 2,
};
export const INFO_GATHER_TYPE = {
  CONTEST: 1,
  NOVICE_TASK: 2,
};

export const SIMULATION_SUBMIT_FLAG = {
  NOT_SUBMIT: 0,
  MANUAL_SUBMIT: 1,
  AUTO_SUBMIT: 2, //被动交卷
};
export const POSTER_PERMISSION = {
  HAS_PERMISSION: 1,
};

export const LOGIN_SOURCE = {
  WEIXIN_SCAN_QRCODE: 'weixin_scan_qrcode',
  PHONE_VERIFY_CODE_PC: 'phone_verify_code_pc',
  PHONE_VERIFY_CODE_H5: 'phone_verify_code_h5',
  HETAO_MINIPROGRAM_CODE_H5: 'hetao_miniprogram_code_h5',
  HETAO_TEMP_CODE: 'hetao_temp_code',
  HETAO_STAFF_TOKEN: 'hetao_staff_token',
  HETAO_PROBLEM_STAFF_TOKEN: 'hetao_problem_staff_token',
  ACCOUNT_PASSWORD: 'account_password',
  WEIXIN_MINIPROGRAM_SCAN_QRCODE: 'weixin_miniprogram_scan_qrcode',
};

export const OI_RANK_OPTIONS = {
  UNKNOWN: 1,
  WITHIN_RANK: 2,
  WITHOUT_RANK: 3,
};

export const CHEAT_MENU_OPTIONS = [
  { label: 'AI', key: 1 },
  { label: '抄袭', key: 2 },
  { label: '非作弊', key: 3 },
];

// 疑似作弊选项
// 题单目前只支持AI识别
export const CHEAT_MENU_OPTIONS_TRAINING = [
  { label: 'AI', value: 1 },
  { label: '无标记', value: 0 },
];

// 疑似作弊选项
export const CHEAT_MENU_OPTIONS_SUSPECTED = [
  { label: 'AI', value: 1 },
  { label: '抄袭', value: 2 },
  { label: '无标记', value: 0 },
];

// 手动判定作弊选项
export const CHEAT_MENU_OPTIONS_MANUAL = [
  { label: 'AI', value: 1 },
  { label: '抄袭', value: 2 },
  { label: '非作弊', value: 3 },
  { label: '无标记', value: 0 },
];

export const TOOLTIP = {
  AI: 'AI风险分:>=0.5分的代码会被判定为作弊。(大数据对作弊行为进行识别，设定了从0-1分的区域分值,0 分最低,1分最高,分数越低疑似作弊概率越低,分数越高疑似作弊概率越高)',
  PLAGIARISM:
    '抄袭风险分:>=0.8 分的代码会被判定为抄袭作弊。(大数据对提交代码进行逐个对比识别，生成对比相似度分数，设定了从0-1分的区域分值,0 分最低,1分最高,分数越低抄袭概率越低,分数越高抄袭概率越高)',
};

export const ASYNC_TASK = {
  TRAINING_SCORE: 'TRAINING_SCORE', // 题单下载完成情况
  GROUP_TRAINING_SCORE: 'GROUP_TRAINING_SCORE', // 小组题单下载完成情况
  CONTEST_SCORE: 'CONTEST_SCORE', // 比赛下载成绩
  GROUP_CONTEST_SCORE: 'GROUP_CONTEST_SCORE', // 小组比赛下载成绩
};

export const IM_MARK_OPTIONS = [
  { value: 0, label: '常规题单' },
  { value: 1, label: '趣味c++年课' },
  { value: 2, label: 'c++两课' },
  { value: 3, label: 'c++一课' },
  { value: 4, label: '竞赛题单' },
];

export const IM_MARK = {
  NORMAL: 0,
  CPP_INTEREST: 1,
  CPP_TWO: 2,
  CPP_ONE: 3,
  COMPETITION: 4,
};

export const SUBMIT_SOURCE_OPTIONS = [
  { label: '核桃OJ', value: 1 },
  { label: '核桃编程APP', value: 2 },
];

export const CHAPTER_POSITION_OPTIONS = [
  { label: '添加在列表最后', value: 0 },
  { label: '添加在列表最前', value: 1 },
];

export const SOLUTION_PERMISSION_OPTIONS = [
  { label: '根据题目本身题解设定', value: 0 },
  { label: '所有人可查看', value: 1 },
  { label: '提交用户可查看', value: 2 },
  { label: '有测试点通过用户可查看', value: 5 },
  { label: '通过用户可查看', value: 3 },
  { label: '管理员可查看', value: 4 },
];

/** 题单「根据题目本身设定」的特殊权限值 */
export const TRAINING_FOLLOW_PROBLEM_VALUE = 0;

export const CONTEST_SHARE_CODE_OPTIONS = [
  { label: '默认关闭', value: 0 },
  { label: '选手自选', value: 1 },
  { label: '强制打开', value: 2 },
];

// 题解标签（数字枚举，与后端保持一致）
export const SOLUTION_LABEL = {
  NORMAL: 0, // 普通（C端不展示 tag）
  SELECTED: 1, // 精选
  OFFICIAL: 2, // 官方
} as const;

export type SolutionLabelType =
  (typeof SOLUTION_LABEL)[keyof typeof SOLUTION_LABEL];

// 用于 B 端列表/弹窗显示文本
export const SOLUTION_LABEL_MAP: Record<number, string> = {
  [SOLUTION_LABEL.OFFICIAL]: '官方',
  [SOLUTION_LABEL.SELECTED]: '精选',
  [SOLUTION_LABEL.NORMAL]: '普通',
};

// 题解来源（数字枚举，与后端对齐：0=用户 1=后台）
export const SOLUTION_SOURCE = {
  USER: 0, // 用户（C端发布）
  BACKEND: 1, // 后台（B端创建）
} as const;

export type SolutionSourceType =
  (typeof SOLUTION_SOURCE)[keyof typeof SOLUTION_SOURCE];

/**
 * AI 改进版本改进原因里的「其他问题」标签。
 * 提交时该标签会从 improveReason 中剔除、由 extraNote 单独承载说明内容，
 * 展示时再由 ImproveReasonBlock 按 extraNote 有无补回，
 * 故提交（EnhanceEditor）、勾选（ImproveReasonModal）、展示（ImproveReasonBlock）三处必须共用同一字面量。
 */
export const AI_SOLUTION_IMPROVE_OTHER_TAG = '其他问题';

// 不通过原因选项
export const SOLUTION_REJECT_REASON_OPTIONS = [
  { label: '无关内容较多，与题目脱节', value: 'irrelevant' },
  { label: '缺少解题思路', value: 'no_idea' },
  { label: '缺少关键实现', value: 'no_impl' },
  { label: '缺少时空复杂度分析', value: 'no_complexity' },
  { label: '缺少边界处理', value: 'no_boundary' },
  { label: '解题思路错误', value: 'wrong_idea' },
  { label: '其他问题', value: 'other' },
];

// 把多选驳回原因的 value（英文 key）翻译成后端要求的汉字文案（rejectReasons 传中文，不传英文）。
// 「其他问题」不作为独立原因入列，仅在补充说明有输入时以其内容作为一项原因，
// 与赛事奖项审核（RejectAwardModal）对「其他」的处理保持一致。
export function buildRejectReasonLabels(
  values: string[],
  supplement: string,
): string[] {
  const labels = values
    .filter((v) => v !== 'other')
    .map(
      (v) =>
        SOLUTION_REJECT_REASON_OPTIONS.find((o) => o.value === v)?.label ?? v,
    );
  if (values.includes('other') && supplement.trim()) {
    labels.push(supplement.trim());
  }
  return labels;
}

/**
 * 驳回原因弹窗的「校验 + 翻译」统一出口，供用户题解管理弹窗与 AI 改进版本管理弹窗共用，
 * 避免两处「至少选一项 / 选其他必填补充 / value→汉字」逻辑各自实现后漂移。
 * 返回 error（可直接 toast 的文案）表示校验不通过；否则 labels 为提交用的汉字原因数组。
 */
export function resolveRejectReasons(
  values: string[],
  supplement: string,
): { error?: string; labels: string[] } {
  if (!values.length) {
    return { error: '请至少选择一项原因', labels: [] };
  }
  const text = supplement.trim();
  if (values.includes('other') && !text) {
    return { error: '选中「其他问题」时补充说明为必填', labels: [] };
  }
  return { labels: buildRejectReasonLabels(values, text) };
}

// OJ 题解默认模板（problemType === 1 时预填）
export const OJ_SOLUTION_TEMPLATE = `### 题意

### 解析

### 标程
\`\`\`cpp

\`\`\``;
